import { css } from 'emotion';

import colors from '@cobliteam/ui/theme/tokens/colors';

export const driverItem = css`
  cursor: pointer;
  height: 40px;
  color: ${colors.gray.dark};
  // hover
  &:hover {
    background-color: ${colors.gray.lightest};
  }
`;

export const driverItemSelected = css`
  height: 40px;
  color: ${colors.gray.dark};
  background-color: ${colors.gray.lightest};
  font-weight: 500;
`;
